<template>
  <div>
    <div class="row">
      <div class="col-xs-1">
        <sui-input-label
          :label="$t('MSG_TXT_SMS_SEND')"
          :vertical="false"
        />
      </div>
      <div class="col-xs-11">
        <div class="comm_label width15">
          {{ this.$t('MSG_TXT_SEND_USR') }}
        </div>
        <div class="comp_spacing" />
        <sui-text-field
          ref="sendPhone"
          v-model.trim="send"
          :placeholder="placeholder"
          :readonly="false"
          :mask="mask"
          maxlength="20"
        />
        <div class="comm_label width15 mrL30">
          {{ this.$t('MSG_TXT_RCPT_USR') }}
        </div>
        <div class="comp_spacing" />
        <sui-text-field
          ref="destPhone"
          v-model.trim="dest"
          :placeholder="placeholder"
          :readonly="false"
          :mask="mask"
          maxlength="20"
        />
        <div class="comp_spacing" />
        <sui-button
          type="button"
          class="comm_sbtn_solid width20"
          @click="onSendClick"
        >
          {{ this.$t('MSG_BTN_SEND') }}
        </sui-button>
      </div>
    </div>
    <div
      v-show="inputAvailable"
      class="row"
    >
      <div class="col-xs-1">
        <sui-input-label
          :label="$t('MSG_TXT_SEND_MSG')"
          :vertical="true"
        />
      </div>
      <div class="col-xs-11">
        <textarea
          ref="messageBody"
          v-model.trim="messageBody"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CmpSmsSend',
  props: {
    pageId: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    inputAvailable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      send: '',
      dest: '',
      oldSend: '',
      oldDest: '',
      messageBody: '',
      validMessage: '',
      mask: 'full-phone',
    };
  },
  computed: {
    sendNum() {
      const send = this.$refs.sendPhone.applyMask(this.send, this.mask);
      return utils.join(utils.split(send, ' - '), '-');
    },
    destNum() {
      const dest = this.$refs.destPhone.applyMask(this.dest, this.mask);
      return utils.join(utils.split(dest, ' - '), '-');
    },
    messageBytes() {
      let bytes = 0;
      for (let i = 0; i < this.messageBody.length; i += 1) {
        const code = this.messageBody.charCodeAt(i);
        if (Math.floor(code / 2048) > 0) {
          bytes += 3;
        } else if (Math.floor(code / 128) > 0) {
          bytes += 2;
        } else {
          bytes += 1;
        }
      }
      return bytes;
    },
    subject() {
      let index = 0;
      let bytes = 0;
      for (let i = 0; i < this.messageBody.length; i += 1) {
        const code = this.messageBody.charCodeAt(i);
        if (Math.floor(code / 2048) > 0) {
          bytes += 3;
        } else if (Math.floor(code / 128) > 0) {
          bytes += 2;
        } else {
          bytes += 1;
        }
        if (bytes < 64) {
          index = i;
        }
      }
      return this.messageBody.substr(0, index + 1);
    },
  },
  watch: {
    message(value) {
      this.messageBody = value;
    },
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getSendData() {
      const lmsFlag = this.messageBytes > 100;
      return {
        messageType: lmsFlag ? 5 : 0,
        sendPhone: this.sendNum,
        destPhone: this.destNum,
        subject: lmsFlag ? this.subject : null,
        messageBody: this.messageBody,
      };
    },
    onSendClick() {
      const sendData = this.getSendData();
      const sendMsg = `${this.$t('MSG_TXT_SEND_USR')}: ${sendData.sendPhone}`;
      const destMsg = `\n${this.$t('MSG_TXT_RCPT_USR')}: ${sendData.destPhone}`;
      const result = this.validation(sendData);
      if (result.valid) {
        utils.messageBox('confirm', this.$t('MSG_ALT_IS_SEND'), sendMsg + destMsg, () => {
          http.request(this.pageId, 'DTS_CMZ_00101', {
            data: sendData,
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_SEND'), null, this.reset);
          }).catch(error => {
            console.log(error);
          });
        });
      } else {
        utils.messageBox('warning', result.message, null, () => {
          if (!utils.isEmpty(result.focus)) {
            this.$refs[result.focus].setFocus();
          }
        });
      }
    },
    validation(data) {
      const result = {
        valid: true,
        message: '',
        focus: '',
      };
      if (utils.isEmpty(data.sendPhone)) {
        result.valid = false;
        result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_SEND_USR'));
        result.focus = 'sendPhone';
        return result;
      }
      if (utils.isEmpty(data.destPhone)) {
        result.valid = false;
        result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RCPT_USR'));
        result.focus = 'destPhone';
        return result;
      }
      if (!utils.isPhoneNumber(data.sendPhone) || !utils.isPhoneNumber(data.destPhone)) {
        result.valid = false;
        result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_TEL'));
        return result;
      }
      if (utils.isEmpty(data.messageBody)) {
        result.valid = false;
        result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_SEND_MSG'));
        return result;
      }
      return result;
    },
    reset() {
      this.send = '';
      this.dest = '';
      this.oldSend = '';
      this.oldDest = '';
      this.messageBody = '';
    },
    focus(target = 'send') {
      if (utils.isEqual(target, 'send')) {
        this.$refs.sendPhone.setFocus();
      } else {
        this.$refs.destPhone.setFocus();
      }
    },
  },
};
</script>
<style scoped>
</style>
